/** The `agentKeys` area: the account page's agent keys section. Owned by the
 *  stage 2 slot components-b (docs/I18N.md §11). */
export const agentKeys = {
  /** The name a key's program acts under in the record: an identifier, the
   *  same in every language. */
  'agentKeys.machineRef': 'automation:{machine}',
  /** `machine`: the key's machine ref, in its own span. */
  'agentKeys.minted': 'Key for {machine}. Shown once; copy it now.',
  /** `env` and `file`: the two ways to hand the key over, each in its own span. */
  'agentKeys.mcpHint': 'For the MCP server: {env} or save it to {file}.',
  /** Code the person copies: the same in every language. */
  'agentKeys.env': 'COORD_API_KEY=<key>',
  'agentKeys.file': 'coord/.key',
  'agentKeys.copy': 'Copy',
  'agentKeys.done': 'OK',
  'agentKeys.revoked': 'revoked',
  'agentKeys.revoke': 'Revoke',
  'agentKeys.machine.label': 'Machine id',
  'agentKeys.machine.placeholder': 'machine id',
  'agentKeys.label.label': 'Label',
  'agentKeys.label.placeholder': 'label',
  /** The label a key gets when none is typed. */
  'agentKeys.label.default': '{machine} (agent)',
  'agentKeys.mint': 'Mint key',
  'agentKeys.may': 'May',
  'agentKeys.may.label': 'What the key may do',
  /** The three access levels, in the same words the connector page uses
   *  (docs/AGENT_ACCESS.md §6a). */
  'agentKeys.may.read': 'See only',
  'agentKeys.may.write': 'See and change',
  'agentKeys.may.manage': 'See, change and share',
  'agentKeys.under': 'Under',
  'agentKeys.under.remove': 'Remove {title}',
  'agentKeys.under.limit': 'Only under an item…',
  'agentKeys.under.add': 'Add an item…',
  'agentKeys.pick.title': 'Limit the key',
  'agentKeys.pick.subtitle': 'The key reaches this item and everything below it.',
  'agentKeys.pick.search': 'Search for an item the key may reach',

  // --- Where an agent acts (docs/AGENT_ACCESS.md §4), shared by the keys
  // section and /connect (`AgentReachChoice`), so never says key. The group
  // names are the person's own words. ---
  'agentKeys.reach.label': 'Where',
  /** The two answers to Where. `groups` when the person has groups,
   *  `ownOnly` when they have none. */
  'agentKeys.reach.everything': 'Everything',
  'agentKeys.reach.groups': 'Only in these groups',
  'agentKeys.reach.ownOnly': 'Only your own items',
  /** The name of the list of the person's groups, for screen readers. */
  'agentKeys.reach.groupList': 'Your groups',
  /** A group's name beside its org's, when two of the person's groups
   *  share a name. */
  'agentKeys.reach.groupInOrg': '{group} in {org}',
  'agentKeys.reach.own': 'Your own items',
  'agentKeys.reach.ownHint':
    'Items you created, hold a seat on, or that were shared with you by name.',
  'agentKeys.reach.left': {
    one: 'It also named a group you have left. That group is dropped.',
    other: 'It also named {count} groups you have left. Those groups are dropped.',
  },
  'agentKeys.reach.empty': 'Pick at least one group, or your own items.',
  /** The folded Where row, in one line. */
  'agentKeys.reach.line.everything': 'Everywhere',
  'agentKeys.reach.line.groups': { one: 'In 1 group', other: 'In {count} groups' },
  'agentKeys.reach.line.groupsOwn': {
    one: 'In 1 group, and your own items',
    other: 'In {count} groups, and your own items',
  },
  'agentKeys.reach.line.own': 'Only your own items',
  'agentKeys.reach.line.under': { one: 'under 1 item', other: 'under {count} items' },

  // --- Where, in the list of keys and of connected apps. `groups`: the
  // groups' names; a group the person has left reads `leftGroup`. ---
  'agentKeys.where.everything': 'everything you can see',
  'agentKeys.where.groups': 'only in {groups}',
  'agentKeys.where.groupsOwn': 'only in {groups}, and your own items',
  'agentKeys.where.own': 'only in your own items',
  'agentKeys.where.leftGroup': 'a group you have left',
  'agentKeys.where.under': 'under {items}',
  'agentKeys.where.hiddenItem': 'an item you cannot see',
} as const;
